import { CUSTOMER_TYPE_FLOW_HOURLY, CUSTOMER_TYPE_FLOW_MONTHLY } from 'grs/constants'
import { SEARCH_MODE_HOURLY, SEARCH_MODE_MONTHLY } from 'search/constants'

export const customerFlowType = searchMode => {
    if (searchMode === SEARCH_MODE_HOURLY) return CUSTOMER_TYPE_FLOW_HOURLY
    if (searchMode === SEARCH_MODE_MONTHLY) return CUSTOMER_TYPE_FLOW_MONTHLY
    return
}
